import React from 'react';
import Modal from 'components/common/Modal';
import { formatarMoeda } from '../../utils/formatadores';

const ModalListaContas = ({ isOpen, onClose, contas, titulo }) => {
  const getStatusInfo = (status) => {
    switch (status) {
      case 'vencida':
        return { label: 'Vencida', color: 'text-red-600', bgColor: 'bg-red-50' };
      case 'proxima_vencimento':
        return { label: 'Próxima', color: 'text-yellow-600', bgColor: 'bg-yellow-50' };
      case 'hoje':
        return { label: 'Hoje', color: 'text-orange-600', bgColor: 'bg-orange-50' };
      case 'paga':
        return { label: 'Paga', color: 'text-green-600', bgColor: 'bg-green-50' };
      case 'paga_parcialmente':
        return { label: 'Paga Parcial', color: 'text-blue-600', bgColor: 'bg-blue-50' };
      case 'cancelada':
        return { label: 'Cancelada', color: 'text-[color:var(--text-muted)]', bgColor: 'bg-[color:var(--surface-muted)]' };
      default:
        return { label: 'Em Aberto', color: 'text-blue-600', bgColor: 'bg-blue-50' };
    }
  };

  const formatarData = (dataString) => {
    if (!dataString) return '-';
    try {
      const data = new Date(dataString);
      return data.toLocaleDateString('pt-BR');
    } catch {
      return dataString;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={titulo} size="full">
      <div className="space-y-4">
        <div className="text-sm text-[color:var(--text-muted)] mb-4 font-medium">
          {contas.length} conta{contas.length !== 1 ? 's' : ''} encontrada{contas.length !== 1 ? 's' : ''}
        </div>
        
        {contas.length === 0 ? (
          <div className="text-center py-8 text-[color:var(--text-muted)]">
            Nenhuma conta encontrada
          </div>
        ) : (
          <div className="border border-[color:var(--border)] rounded-lg overflow-hidden">
            <div className="overflow-y-auto max-h-[65vh]">
              <table className="w-full divide-y divide-[color:var(--border)]">
                <thead className="bg-[color:var(--surface-muted)] sticky top-0 z-10">
                  <tr>
                    <th className="px-3 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider w-20">
                      ID
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider min-w-[200px] max-w-[250px]">
                      Fornecedor
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider min-w-[200px]">
                      Descrição
                    </th>
                    <th className="px-3 py-3 text-right text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider w-28">
                      Valor
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider w-32">
                      Vencimento
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-[color:var(--text-muted)] uppercase tracking-wider w-32">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-[color:var(--surface)] divide-y divide-[color:var(--border)]">
                  {contas.map((conta) => {
                    const statusInfo = getStatusInfo(conta.status);
                    return (
                      <tr key={conta.id} className="hover:bg-[color:var(--surface-muted)]">
                        <td className="px-3 py-3 whitespace-nowrap text-xs text-[color:var(--text-muted)] font-mono">
                          #{conta.id}
                        </td>
                        <td className="px-3 py-3 text-sm text-[color:var(--text-primary)]">
                          <div className="font-medium truncate" title={conta.fornecedor || '-'}>
                            {conta.fornecedor || '-'}
                          </div>
                          {conta.categoria && (
                            <div className="text-xs text-[color:var(--text-muted)] truncate" title={conta.categoria}>
                              {conta.categoria}
                            </div>
                          )}
                        </td>
                        <td className="px-3 py-3 text-sm text-[color:var(--text-primary)]">
                          <div className="truncate max-w-md" title={conta.descricao || '-'}>
                            {conta.descricao || '-'}
                          </div>
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm font-medium text-[color:var(--text-primary)] text-right">
                          {formatarMoeda(conta.valor || 0)}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-sm text-[color:var(--text-muted)]">
                          {formatarData(conta.data_vencimento_convertida || conta.dataVencimento)}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${statusInfo.bgColor} ${statusInfo.color}`}>
                            {statusInfo.label}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalListaContas;




